(function () {
  'use strict';

  angular.module('unit.type.change', ['ngResource']);
})();
